import { useState, useEffect } from "react"
import { fetchEntity } from "network/network"
import { getEntityId, getCustomerId } from "../lib/filters.js"
import Loader from "@common/loader"
import Tooltip from "@common/tooltip"
import { useDashboardContext } from "../context/dashboardContext.js"
import { useRouter } from "next/router.js"
import { getShareableUrlId } from "lib/navigation"

// tempEntityName -> only used till name is fetched
export default function EntityName({
  entityId,
  categoryId,
  tempEntityName,
  selectMsg,
}) {
  const { entityObj } = useDashboardContext() // for primary entityId in url
  const [finalEntityObj, setFinalEntityObj] = useState()
  const router = useRouter()
  const { demo } = router.query
  const eId = entityId ?? getEntityId()
  const shouldFetchEntityObj = eId && eId != entityObj?.id ? true : false
  const shareableUrlId = getShareableUrlId(router.query)
  const { entity } = fetchEntity(
    getCustomerId(),
    eId,
    categoryId,
    shouldFetchEntityObj,
    null,
    demo,
    shareableUrlId
  )

  useEffect(() => {
    setFinalEntityObj(shouldFetchEntityObj == false ? entityObj : null)
  }, [entityObj])

  useEffect(() => {
    if (shouldFetchEntityObj == true && entity && Object.keys(entity).length !== 0)
      setFinalEntityObj(entity)
  }, [entity])

  if (!finalEntityObj || Object.keys(finalEntityObj).length == 0) return <Loader />

  if (Object.keys(finalEntityObj).length == 0 && !tempEntityName)
    return (
      <div className="md:w-72">
        <div className="cursor-pointeri text-gray-700 dark:text-gray-300 hover:text-gray-800 dark:text-gray-200 text-md bg-gray-200  dark:bg-gray-900  rounded-xl px-4 py-2 outline-none">
          {selectMsg ? selectMsg : "Select Entity"}
        </div>
      </div>
    )

  const nameInEntityObj = "name" in finalEntityObj ? finalEntityObj.name : null
  let displayName = nameInEntityObj || tempEntityName

  // special case - during edit of group name, finalEntityObj may have older name but tempEntityName has newer name
  if (tempEntityName && finalEntityObj.name != tempEntityName)
    displayName = tempEntityName

  return (
    <Tooltip>
      <Tooltip.Trigger>{displayName}</Tooltip.Trigger>
      <Tooltip.Content>{displayName}</Tooltip.Content>
    </Tooltip>
  )
}
